
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SHIPMENTS"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Basket"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipments"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shipmentId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productSubTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_deliveryIndicator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_orderNo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vibesSmsPhoneNo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"itemsCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bossMaxDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bossMinDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_fromStoreId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shippingAddress"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"address2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"city"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"countryCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"postalCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"phone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stateCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_altName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_altEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_emailAddress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_addressId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_addressType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_validationCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_phoneCountryCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_storeHours"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_storeName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isStoreBOSSEligible"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"storePhoneNo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"shippingMethod"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"c_code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"price"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"shipmentTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"discountedAmount"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":1312}};
    doc.loc.source = {"body":"fragment SHIPMENTS on Basket {\n  shipments {\n    shipmentId\n    productSubTotal\n    productTotal\n    c_deliveryIndicator\n    c_orderNo\n    vibesSmsPhoneNo\n    itemsCount\n    bossMaxDate\n    bossMinDate\n    c_fromStoreId\n    shippingAddress {\n      id\n      address1\n      address2\n      city\n      countryCode\n      firstName\n      postalCode\n      phone\n      lastName\n      stateCode\n      c_altName\n      c_altEmail\n      c_emailAddress\n      c_addressId\n      c_addressType\n      c_validationCode\n      c_phoneCountryCode\n      c_storeHours\n      c_storeName\n      isStoreBOSSEligible\n      storePhoneNo\n      # SFCC-TODO to remove in future\n      # companyName\n      # fullName\n      # postBox\n      # jobTitle\n      # title\n      # suite\n      # suffix\n      # secondName\n      # salutation\n    }\n    shippingMethod {\n      id\n      # SFCC-TODO to remove in future\n      description\n      c_code\n      # shippingPromotions\n      price\n      name\n      # externalShippingMethod\n    }\n    shipmentTotal\n    discountedAmount\n    # adjustedMerchandizeTotalTax\n    # adjustedShippingTotalTax\n    # gift\n    # giftMessage\n    # merchandizeTotalTax\n    # productSubTotal\n    # shipmentNo\n    # productTotal\n    # shippingStatus\n    # shippingTotal\n    # shippingTotalTax\n    # trackingNumber\n    # taxTotal\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SHIPMENTS"] = oneQuery(doc, "SHIPMENTS");
        
